/** Debe mantenerse alineado con `auth/permissions.py` del backend. */
export const ROLE_PERMISSIONS: Record<string, readonly string[]> = {
  staff: [
    'users.read', 'contacts.read', 'bug_reports.review', 'content.read',
    'events.read', 'moderation.review', 'media.manage', 'documents.manage', 'ai.use',
  ],
  admin: [
    'users.manage', 'notifications.broadcast', 'content.manage', 'events.manage',
    'moderation.manage', 'memberships.manage', 'certificates.manage', 'mcp_tokens.manage',
  ],
  sysadmin: [
    'system.read', 'system.logs.read', 'system.config.manage',
    'system.services.manage', 'system.deploy', 'system.permissions.manage',
  ],
};

export function permissionsForRoles(roles: readonly string[]): string[] {
  return [...new Set(roles.flatMap((role) => ROLE_PERMISSIONS[role] ?? []))].sort();
}

export function hasAnyPermission(permissions: readonly string[], needed: readonly string[]): boolean {
  return needed.some((permission) => permissions.includes(permission));
}
